import { AlkLogger } from '@alk/core';
import { EAuthenticationMode } from '../../enums';
import { IAuthenticationService } from './authentication.interface';
import { IAuthenticationTokens, IError, IJWT, IUserAuthentication } from '../../interfaces';
import { injectable } from 'inversify';

@injectable()
export abstract class AuthenticationService implements IAuthenticationService {
    login(userId: string, password: string): Promise<[ IJWT, IError? ]> {
        AlkLogger.info('[AuthenticationService#login]', userId, password);

        throw new Error('[AuthenticationService#login] This method must be overridden !');
    }

    logout() {
        sessionStorage.setItem('SFX_IS_LOGGED', 'false');
        sessionStorage.removeItem('USER');
        sessionStorage.removeItem('SFX_TOKENS');
        sessionStorage.removeItem('SFX_AUTH_MODE');

        /**
         * NOTE: We do that hard reload for 2 reasons:
         * - Some of our user never close the app so we can have some issues when releasing
         * a new version.
         * - We don't handle the login state as a stream on the router.
         * TODO: We need to rework this part but we have to solve the above issues before.
         * See the following commit: 843548788246e13ecf99ed0626cea63229cf6e5f
         */
        location.href = '/';
        location.reload();

        return Promise.resolve();
    }

    refresh(): Promise<void> {
        AlkLogger.info('[AuthenticationService#refresh]');

        return Promise.resolve();
    }

    isLogged(): Promise<boolean> {
        return Promise.resolve(Boolean(JSON.parse(sessionStorage.getItem('SFX_IS_LOGGED'))));
    }

    getCurrentUser(): Promise<IUserAuthentication> {
        return Promise.resolve(JSON.parse(sessionStorage.getItem('USER')));
    }

    getToken(): IAuthenticationTokens {
        return JSON.parse(sessionStorage.getItem('SFX_TOKENS'));
    }

    getAuthenticationMode(): EAuthenticationMode {
        return sessionStorage.getItem('SFX_AUTH_MODE') as EAuthenticationMode;
    }
}
